import { useState } from "react";
import { Avatar, MenuItem, ListItemIcon, Divider, Badge, IconButton, Menu, useTheme } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { useSession } from "../lib/hooks";
import { useNavigate } from "react-router-dom";
import { HrefMenuItem } from "../lib/common";

function UserTopAvatar() {
  const navigate = useNavigate();
  const { session, logout } = useSession();
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const theme = useTheme();

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  function handleLogout() {
    logout();
    navigate("/");
    handleCloseMenu();
  }

  const innerChildren = (
    <Avatar sx={{ bgcolor: "white" }}>
      <IconButton disabled={!session.authenticated} size={"large"} color={"primary"} onClick={handleOpenMenu}>
        <PersonOutlineIcon fontSize="inherit" />
      </IconButton>
    </Avatar>
  );

  if (session.authenticated) {
    const menu = (
      <Menu
        open={openMenu}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}>
        <HrefMenuItem href="/user" onClick={handleCloseMenu}>
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          {session.user.firstName} {session.user.lastName}
        </HrefMenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          Odhlásit
        </MenuItem>
      </Menu>
    );

    return (
      <Badge
        color={"success"}
        overlap={"circular"}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        variant={"dot"}
        sx={{
          "& .MuiBadge-badge": {
            border: `1px solid ${theme.palette.background.paper}`,
          },
          transition: "transform 0.2s",
          "&:hover": {
            transform: "scale(1.1)",
          },
        }}>
        {menu}
        {innerChildren}
      </Badge>
    );
  } else {
    return innerChildren;
  }
}

export default UserTopAvatar;
